// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".textarea-header-actions[data-v-60d3b5a8] .v-btn.v-size--x-small{font-size:10px;height:20px;min-width:120px;padding:0 8px;width:120px}.textarea-header-actions>div[data-v-60d3b5a8]{align-items:center;display:flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
